import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { store } from "./store/store";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";

const CLIENT_ID = process.env.REACT_APP_GCP_CLIENT_ID;

createRoot(document.getElementById("app")).render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </GoogleOAuthProvider>
  </Provider>
);
